import CrudRequest from 'Arch/components/crud/CrudRequest';
import httpService from 'Arch/services/HttpService';

export default class DlqRequest extends CrudRequest {
  static baseUrl() {
    return '/dlq/messages';
  }

  static reprocess(id) {
    return httpService.put(
      `${this.baseUrl()}/reprocessar`,
      {
        id,
      },
    );
  }

  static list(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/list-all`,
      {
        params,
      },
    );
  }

  static history(params = {}) {
    return httpService.get(
      `${this.baseUrl()}/history/list-all`,
      {
        params,
      },
    );
  }

  static getHistory(id) {
    return httpService.get(
      `${this.baseUrl()}/history/${id}`,
    );
  }

  static cancel(id) {
    return httpService.put(
      `${this.baseUrl()}/cancelar/${id}`,
    );
  }
}
